import React, { useEffect } from "react";

import { useNavigate, useLocation } from "react-router-dom";
import styles from "./Menubar.module.css";

import { motion } from "framer-motion";

// ICONs
import shopIcon from "/ShopIcon.svg";
import tasksIcon from "/TaskIcon.svg";
import miningIcon from "/dreamcoin-logo.svg";
import referrerIcon from "/RefIcon.svg";
import profileIcon from "/ProfileIcon.svg";

import shopIconActive from "/ShopIcon_active.svg";
import tasksIconActive from "/TaskIcon_active.svg";
import referrerIconActive from "/RefIcon_active.svg";
import profileIconActive from "/ProfileIcon_active.svg";

export default function Menubar() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigate = (path) => {
    navigate(path);
  };
  console.log("Styles:", styles);

  // Варианты анимации с использованием CSS-фильтров
  const pulseVariants = {
    pulse: {
      scale: [1, 1.2, 1],
      filter: [
        "drop-shadow(0 0 0px rgba(155, 122, 255, 0))",
        "drop-shadow(0 0 4px rgba(155, 122, 255, 0.7))",
        "drop-shadow(0 0 0px rgba(155, 122, 255, 0))",
      ],
      transition: {
        duration: 1.5,
        ease: "easeInOut",
        times: [0, 0.5, 1],
        repeat: Infinity,
        repeatType: "loop",
      },
    },
  };
  // Варианты анимации с использованием CSS-фильтров

  return (
    <nav className={styles.menubar}>
      <div className={styles.menuContainer}>
        {/* Левая секция */}
        <div className={styles.menuSection}>
          <button
            className={`${styles.menuItem} ${
              location.pathname === "/shop" ? styles.active : ""
            }`}
            onClick={() => handleNavigate("/shop")}
          >
            <span className={styles.icon}>
              <img
                src={shopIcon}
                alt="Shop"
                className={`${styles.svgIcon} ${styles.defaultIcon} ${
                  location.pathname === "/shop" ? styles.hidden : ""
                }`}
              />
              <img
                src={shopIconActive}
                alt="Shop Active"
                className={`${styles.svgIcon} ${styles.activeIcon} ${
                  location.pathname === "/shop" ? "" : styles.hidden
                }`}
              />
            </span>
            <span className={styles.label}>Магазин</span>
          </button>

          <button
            className={`${styles.menuItem} ${
              location.pathname === "/earn" ? styles.active : ""
            }`}
            onClick={() => handleNavigate("/earn")}
          >
            <span className={styles.icon}>
              <motion.div
                className={styles.notificationDot}
                variants={pulseVariants}
                animate="pulse"
                style={{
                  willChange: "transform, filter",
                  transform: "translateZ(0)",
                }}
              />
              <img
                src={tasksIcon}
                alt="Tasks"
                className={`${styles.svgIcon} ${styles.defaultIcon} ${
                  location.pathname === "/earn" ? styles.hidden : ""
                }`}
              />
              <img
                src={tasksIconActive}
                alt="Tasks Active"
                className={`${styles.svgIcon} ${styles.activeIcon} ${
                  location.pathname === "/earn" ? "" : styles.hidden
                }`}
              />
            </span>
            <span className={styles.label}>Задания</span>
          </button>
        </div>

        {/* Центральная кнопка */}
        <button
          className={`${styles.menuItem} ${styles.miningButton} ${
            location.pathname === "/" && styles.active
          }`}
          onClick={() => handleNavigate("/")}
        >
          <span className={styles.icon}>
            <img
              src={miningIcon}
              alt="Mining"
              className={`${styles.svgIcon} ${styles.miningIcon}`}
            />
          </span>
        </button>

        {/* Правая секция */}
        <div className={styles.menuSection}>
          <button
            className={`${styles.menuItem} ${
              location.pathname === "/referrer" ? styles.active : ""
            }`}
            onClick={() => handleNavigate("/referrer")}
          >
            <span className={styles.icon}>
              <img
                src={referrerIcon}
                alt="Referrer"
                className={`${styles.svgIcon} ${styles.defaultIcon} ${
                  location.pathname === "/referrer" ? styles.hidden : ""
                }`}
              />
              <img
                src={referrerIconActive}
                alt="Referrer Active"
                className={`${styles.svgIcon} ${styles.activeIcon} ${
                  location.pathname === "/referrer" ? "" : styles.hidden
                }`}
              />
            </span>
            <span className={styles.label}>Друзья</span>
          </button>

          <button
            className={`${styles.menuItem} ${
              location.pathname === "/profile" ? styles.active : ""
            }`}
            onClick={() => handleNavigate("/profile")}
          >
            <span className={styles.icon}>
              <img
                src={profileIcon}
                alt="Profile"
                className={`${styles.svgIcon} ${styles.defaultIcon} ${
                  location.pathname === "/profile" ? styles.hidden : ""
                }`}
              />
              <img
                src={profileIconActive}
                alt="Profile Active"
                className={`${styles.svgIcon} ${styles.activeIcon} ${
                  location.pathname === "/profile" ? "" : styles.hidden
                }`}
              />
            </span>
            <span className={styles.label}>Профиль</span>
          </button>
        </div>
      </div>
    </nav>
  );
}
